/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import SortingArrow from 'components/SortingArrow'
import sortDirection from 'constants/sortDirection'
import ExternalLinkIcon from 'assets/icons/external-link-icon'
import OptionIcon from 'assets/icons/options-icon'
import capitalize from 'utils/capitalize'
import { getStickyTableColumnsLength } from 'utils/getStickyTableColumnsLength'
import { ReportsFactsheetIconWrapper, ReportsFactsheetWrapper } from '../style'
import { renderSitesStatusIcon } from '../../SitesManagement/sitesTable'
import { SortingArrowWrapper } from 'components/SortingArrow/style'

export const makeHabitatsTabRow = (tableData) => {
  if (!Array.isArray(tableData)) {
    return []
  }

  const formatPercentage = (val) => {
    if (val === null || val === undefined || val === '') return '-'
    const num = Number(val)
    return Number.isNaN(num) ? `${val}%` : `${num}%`
  }

  return tableData.map((item) => {
    const siteStatus = item.kbaStatus
    return {
      siteCode: item.siteCode || item.SiteId || item.siteId || '-',
      region: Array.isArray(item.region) ? item.region.join(', ') : (item.region || '-'),
      country: Array.isArray(item.country) ? item.country.join(', ') : (item.country || item.countryLabel || '-'),
      siteName: item.siteName || item.siteNameEng || '-',
      year: item.year != null ? item.year : '-',
      SiteStatusId: (
        <>
          {renderSitesStatusIcon(siteStatus)}
          {capitalize(siteStatus)}
        </>
      ),
      kbaClassification: item.kbaClassification || '-',
      habitatLevel1: item.habitatLevel1 || '-',
      habitatLevel2: item.habitatLevel2 || '-',
      habitatLevel3: item.habitatLevel3 || '-',
      percentageOfSite: formatPercentage(item.percentageOfSite),
      options: (
        <ReportsFactsheetWrapper>
          <ReportsFactsheetIconWrapper>
            <ExternalLinkIcon />
          </ReportsFactsheetIconWrapper>
          <ReportsFactsheetIconWrapper>
            <OptionIcon />
          </ReportsFactsheetIconWrapper>
        </ReportsFactsheetWrapper>
      )
    }
  })
}

export const makeHabitatsTabColumns = (sorting, setSorting, rows = []) => {
  const sortFunction = (sortBy) => {
    if (sorting.sortBy === sortBy) {
      if (sorting.sortDirection === sortDirection.ASC) {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.DESC })
      } else {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
      }
    } else {
      setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
    }
  }

  const sortBySiteId = () => {
    sortFunction('siteCode')
  }

  const sortByRegion = () => {
    sortFunction('region')
  }

  const sortByCountry = () => {
    sortFunction('country')
  }

  const sortBySiteName = () => {
    sortFunction('siteName')
  }

  const sortByAssessmentDate = () => {
    sortFunction('year')
  }

  const sortByKbaStatus = () => {
    sortFunction('SiteStatusId')
  }

  const sortByKbaClassification = () => {
    sortFunction('kbaClassification')
  }

  const sortByHabitatLevel1 = () => {
    sortFunction('habitatLevel1')
  }

  const sortByHabitatLevel2 = () => {
    sortFunction('habitatLevel2')
  }

  const sortByHabitatLevel3 = () => {
    sortFunction('habitatLevel3')
  }

  const sortByPercentageOfSite = () => {
    sortFunction('percentageOfSite')
  }

  return [
    {
      id: 'siteCode',
      sticky: 'left',
      width: getStickyTableColumnsLength('siteCode', rows, 130),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteId' />
          <SortingArrow
            onChange={sortBySiteId}
            checked={sorting.sortBy === 'siteCode' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteCode',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'region',
      width: getStickyTableColumnsLength('region', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='region' />
          <SortingArrow
            onChange={sortByRegion}
            checked={sorting.sortBy === 'region' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'region',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'country',
      width: getStickyTableColumnsLength('country', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='country' />
          <SortingArrow
            onChange={sortByCountry}
            checked={sorting.sortBy === 'country' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'country',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteName',
      width: getStickyTableColumnsLength('siteName', rows, 200),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteName' />
          <SortingArrow
            onChange={sortBySiteName}
            checked={sorting.sortBy === 'siteName' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteName',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'year',
      width: getStickyTableColumnsLength('year', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='yearOfAssessment' />
          <SortingArrow
            onChange={sortByAssessmentDate}
            checked={sorting.sortBy === 'year' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'year',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'SiteStatusId',
      width: getStickyTableColumnsLength('SiteStatusId', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaStatus' />
          <SortingArrow
            onChange={sortByKbaStatus}
            checked={sorting.sortBy === 'SiteStatusId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'SiteStatusId',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaClassification',
      width: getStickyTableColumnsLength('kbaClassification', rows, 175),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaClassification' />
          <SortingArrow
            onChange={sortByKbaClassification}
            checked={sorting.sortBy === 'kbaClassification' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'kbaClassification',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'habitatLevel1',
      width: getStickyTableColumnsLength('habitatLevel1', rows, 180),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='habitatLevel1' />
          <SortingArrow
            onChange={sortByHabitatLevel1}
            checked={sorting.sortBy === 'habitatLevel1' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'habitatLevel1',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'habitatLevel2',
      width: getStickyTableColumnsLength('habitatLevel2', rows, 200),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='habitatLevel2' />
          <SortingArrow
            onChange={sortByHabitatLevel2}
            checked={sorting.sortBy === 'habitatLevel2' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'habitatLevel2',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'habitatLevel3',
      width: getStickyTableColumnsLength('habitatLevel3', rows, 200),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='habitatLevel3' />
          <SortingArrow
            onChange={sortByHabitatLevel3}
            checked={sorting.sortBy === 'habitatLevel3' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'habitatLevel3',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'percentageOfSite',
      width: getStickyTableColumnsLength('percentageOfSite', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='percentageOfSite' />
          <SortingArrow
            onChange={sortByPercentageOfSite}
            checked={sorting.sortBy === 'percentageOfSite' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'percentageOfSite',
      cell: ({ getValue }) => getValue()
    }
  ]
}
